/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Site,
    SiteFromJSON,
    SiteToJSON,
} from '../models/Site';

export interface CreateSiteRequest {
    /**
     * 
     */
    site: Site;
}

export interface DeleteSiteRequest {
    /**
     * 
     */
    id: string;
}

export interface GetSiteRequest {
    /**
     * 
     */
    id: string;
}

export interface UpdateSiteRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    site: Site;
}

/**
 * 
 */
export class SiteControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for createSite without sending the request
     */
    async createSiteRequestOpts(requestParameters: CreateSiteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['site'] == null) {
            throw new runtime.RequiredError(
                'site',
                'Required parameter "site" was null or undefined when calling createSite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/sites`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SiteToJSON(requestParameters['site']),
        };
    }

    /**
     */
    async createSiteRaw(requestParameters: CreateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Site>> {
        const requestOptions = await this.createSiteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteFromJSON(jsonValue));
    }

    /**
     */
    async createSite(requestParameters: CreateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Site> {
        const response = await this.createSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteSite without sending the request
     */
    async deleteSiteRequestOpts(requestParameters: DeleteSiteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteSite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/sites/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteSiteRaw(requestParameters: DeleteSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteSiteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteSite(requestParameters: DeleteSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSiteRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAllSites without sending the request
     */
    async getAllSitesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/sites`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllSitesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Site>>> {
        const requestOptions = await this.getAllSitesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SiteFromJSON));
    }

    /**
     */
    async getAllSites(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Site>> {
        const response = await this.getAllSitesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSite without sending the request
     */
    async getSiteRequestOpts(requestParameters: GetSiteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/sites/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getSiteRaw(requestParameters: GetSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Site>> {
        const requestOptions = await this.getSiteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteFromJSON(jsonValue));
    }

    /**
     */
    async getSite(requestParameters: GetSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Site> {
        const response = await this.getSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateSite without sending the request
     */
    async updateSiteRequestOpts(requestParameters: UpdateSiteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSite().'
            );
        }

        if (requestParameters['site'] == null) {
            throw new runtime.RequiredError(
                'site',
                'Required parameter "site" was null or undefined when calling updateSite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/sites/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SiteToJSON(requestParameters['site']),
        };
    }

    /**
     */
    async updateSiteRaw(requestParameters: UpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Site>> {
        const requestOptions = await this.updateSiteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteFromJSON(jsonValue));
    }

    /**
     */
    async updateSite(requestParameters: UpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Site> {
        const response = await this.updateSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
